module.exports = __webpack_public_path__ + "img/numbers.5b5e299f.png";